import _ from 'underscore';
import Flux from 'lib/flux';
import BookingService from 'services/booking';
import BookingConstants from 'constants/booking';
import { dispatch } from 'lib/exp/flux';

const BookingActionCreator = Flux.createActionCreator({
  decline(params) {
    this.dispatchAction(BookingConstants.REJECT);
    BookingService.decline(_.extend({}, params, { medium: 'Email' })).then(
      (resp) => {
        this.dispatchAction(BookingConstants.REJECT_COMPLETED, resp);
      },
      (errors) => {
        this.dispatchAction(BookingConstants.REJECT_FAILED, errors);
      }
    );
  },

  accept(params) {
    this.dispatchAction(BookingConstants.ACCEPT);
    BookingService.accept(_.extend({}, params, { medium: 'Email' })).then(
      (resp) => {
        this.dispatchAction(BookingConstants.ACCEPT_COMPLETED, resp);
      },
      (errors) => {
        this.dispatchAction(BookingConstants.ACCEPT_FAILED, errors);
      }
    );
  },

  invoiceGuest(params) {
    const onCompleted = (resp) => {
      dispatch({ type: 'BOOKING_INVOICE_GUEST_COMPLETED', payload: resp });
    };
    const onRejected = (resp) => {
      dispatch({
        type: 'BOOKING_INVOICE_GUEST_FAILED',
        payload: resp.responseJSON || {},
      });
    };
    dispatch({ type: 'BOOKING_INVOICE_GUEST' });
    BookingService.invoiceGuest(params).then(onCompleted, onRejected);
  },

  invoiceGuestReset() {
    dispatch({ type: 'BOOKING_INVOICE_GUEST_RESET' });
  },
});

export default BookingActionCreator;
